const doc = [({"ko":({"adminConstantHotelQuestionAnswerType":({"radio":"선택(라디오 버튼)", "selectTag":"선택(풀다운)", "text":"자유 입력(1줄)", "textarea":"자유 입력(다중)"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;